export default __webpack_public_path__ + "static/media/shoes3.472a3ead.jpeg";